import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import logo from '../../assets/logo.webp'
import { getAllAnswers } from '../../utils/onboardingStorage'

// Green checkmark SVG component
const GreenCheckmark = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_148_8004)">
      <path
        d="M24.5 2.75006C24.5 1.23303 23.267 0 21.7499 0H3.25006C1.73303 0 0.5 1.23303 0.5 2.75006V21.2499C0.5 22.767 1.73303 24 3.25006 24H21.7499C23.267 24 24.5 22.767 24.5 21.2499V2.75006Z"
        fill="#4CAF50"
      />
      <path
        d="M18.5818 8.04333C18.9727 8.43427 18.9727 9.06616 18.5818 9.45728L12.0817 15.9572C11.8867 16.1522 11.6307 16.2503 11.3748 16.2503C11.1188 16.2503 10.8628 16.1522 10.6678 15.9572L7.41785 12.7072C7.02673 12.3163 7.02673 11.6842 7.41785 11.2933C7.80878 10.9022 8.44067 10.9022 8.83179 11.2933L11.3748 13.8362L17.1678 8.04333C17.5588 7.65222 18.1907 7.65222 18.5818 8.04333Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <clipPath id="clip0_148_8004">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default function SyncedPage() {
  const { t } = useTranslation()
  const [visibleItems, setVisibleItems] = useState<number[]>([])

  // Animation effect to show items one by one
  useEffect(() => {
    // Show first item immediately
    setVisibleItems([0])

    // Show remaining items with delay
    const timer1 = setTimeout(() => setVisibleItems([0, 1]), 400)
    const timer2 = setTimeout(() => setVisibleItems([0, 1, 2]), 800)
    const timer3 = setTimeout(() => setVisibleItems([0, 1, 2, 3]), 1200)
    const timer4 = setTimeout(() => setVisibleItems([0, 1, 2, 3, 4]), 1600)

    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
      clearTimeout(timer3)
      clearTimeout(timer4)
    }
  }, [])
  const handleSubmit = () => {
    // If this is the last page of onboarding, send all answers to React Native
    if (window.ReactNativeWebView) {
      const allAnswers = getAllAnswers()
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'ONBOARDING_COMPLETE',
          onboardingAnswers: allAnswers,
        }),
      )
    }
  }

  return (
    <Layout>
      <div className="flex h-full flex-col">
        <div className="mt-11 shrink-0">
          <div className="mb-6 flex justify-center">
            <img src={logo} alt="Logo" className="h-24 w-24" />
          </div>
          <h1 className="custom-heading mb-8 text-center text-3xl">
            {t('pages.onboarding.synced.heading')}
          </h1>
        </div>

        <div className="flex grow flex-col items-center justify-center">
          <div className="w-full max-w-md space-y-4">
            <div className="space-y-4">
              {[
                { key: 0, text: t('pages.onboarding.synced.messagingStyle') },
                { key: 1, text: t('pages.onboarding.synced.riskSettings') },
                { key: 2, text: t('pages.onboarding.synced.icebreakerFlavor') },
                { key: 3, text: t('pages.onboarding.synced.feedbackLevel') },
                { key: 4, text: t('pages.onboarding.synced.energyPacing') },
              ].map((item) => {
                const isVisible = visibleItems.includes(item.key)
                return (
                  <div
                    key={item.key}
                    style={{
                      opacity: isVisible ? 1 : 0,
                      transform: isVisible
                        ? 'translateY(0)'
                        : 'translateY(20px)',
                      transition: 'all 800ms cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                    className="flex items-center space-x-3"
                  >
                    <GreenCheckmark />
                    <span className="text-black">{item.text}</span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <Form
          className="shrink-0"
          method="post"
          onSubmit={handleSubmit}
          style={{ width: '100%' }}
        >
          <Button
            title={t('pages.onboarding.synced.takeToScan')}
            type="submit"
            dataTestId="button-continue"
            className="w-full"
          />
        </Form>
      </div>
    </Layout>
  )
}
